import { Flex } from '@chakra-ui/react';
import { SocialMediaIcons, SocialMediaUrls } from 'src/config';
import { SocialIcon } from './socialIcon';

export interface SocialIconType {
	iconUrl: string;
	linkUrl: string;
}

const socials = [
	{
		iconUrl: SocialMediaIcons.linkedin,
		linkUrl: SocialMediaUrls.linkedIn,
	},
	{
		iconUrl: SocialMediaIcons.telegram,
		linkUrl: SocialMediaUrls.telegram,
	},
	{
		iconUrl: SocialMediaIcons.twitter,
		linkUrl: SocialMediaUrls.twitter,
	},
	{
		iconUrl: SocialMediaIcons.facebook,
		linkUrl: SocialMediaUrls.facebook,
	},
	{
		iconUrl: SocialMediaIcons.instagram,
		linkUrl: SocialMediaUrls.instagram,
	},
];

export const FooterSocials = () => {
	return (
		<Flex gridGap="10px">
			{socials.map(s => {
				return (
					<SocialIcon
						key={s.linkUrl}
						iconUrl={s.iconUrl}
						linkUrl={s.linkUrl}
					/>
				);
			})}
		</Flex>
	);
};
